import React from 'react';

import { Box } from '@opendoor/bricks/core';
import { PropertyCardRow } from 'buying/components/propertyCards/PropertyCardRow';
import { useDevice } from '@opendoor/bricks/hooks/useMedia';
import {
  useGetFeedProperties,
  usePropertiesStats,
  convertBuyerUserFiltersToPropertiesStatsInput,
} from 'buying/graphql/useProperties';
import { OdProtosBuyerServicesBuyer_PropertyRequests_GetFeedPropertiesForCurrentUser_SortKey as FeedSortKey } from '__generated__/globalTypes';
import { useBuyerCurrentUser } from 'buying/graphql/useUser';

/**
 * Property Cards displayed experimentally on the Sell tab
 *
 * storybook-check-ignore
 */
export const PropertyCardsSellTab: React.FC = () => {
  const { isMobile } = useDevice();
  const { data: buyerUser, loading: isBuyingUserDataLoading } = useBuyerCurrentUser();
  const userPropertiesFilter =
    buyerUser?.buyer?.getCurrentUser?.user?.feedPropertiesFilter || undefined;

  const { properties, loading: isPropertiesLoading } = useGetFeedProperties(
    { offset: 0, count: 5 },
    { sortKey: FeedSortKey.SORT_KEY_POPULAR_AT_DESC },
  );

  const { data: propertiesStats, loading: isPropertiesFilterStatsDataLoading } = usePropertiesStats(
    convertBuyerUserFiltersToPropertiesStatsInput(userPropertiesFilter),
  );

  const newHomesCount =
    propertiesStats?.buyer?.getPropertiesStatsForPropertiesFilter?.currentNumberOfProperties;

  const isLoading =
    isPropertiesLoading || isBuyingUserDataLoading || isPropertiesFilterStatsDataLoading;

  return (
    <Box width="100%" mt={8}>
      <PropertyCardRow
        properties={properties.slice(0, isMobile ? 6 : 3)}
        propertyFilters={userPropertiesFilter}
        enableViewMoreCard
        enableExpandFeedCard
        newHomesCount={newHomesCount}
        headerText="Buy any home on the market with Opendoor"
        headerTextMobile="Buy any home on the market"
        isLoading={isLoading}
      />
      {!isMobile && properties.length > 3 && (
        <Box mt={6}>
          <PropertyCardRow
            properties={properties.slice(3, 6)}
            enableViewMoreCard
            enableExpandFeedCard
            isLoading={isLoading}
          />
        </Box>
      )}
    </Box>
  );
};
